module.exports = __webpack_public_path__ + "static/media/my_orders_english.ec4f18c9.jpg";